var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRibbon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 78.864,
    height: 81.635,
    viewBox: "0 0 78.864 81.635",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_748",
    "data-name": "Group 748",
    transform: "translate(-670.211 -3354.607)",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_381",
    "data-name": "Path 381",
    d: "M40.658,13.983,48.627,27.79a4.058,4.058,0,0,1-2.858,6.032l-.458.045-.454,0-11.889-.77L27.686,43.777a4.058,4.058,0,0,1-6.518,1.054l-.332-.381L20.544,44,12.566,30.193a36.458,36.458,0,0,0,28.092-16.21Z",
    transform: "translate(699.372 3389.699)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_382",
    "data-name": "Path 382",
    d: "M39,30.2,31.03,44.011a4.058,4.058,0,0,1-6.575.636l-.308-.405-.259-.462L18.6,33.1l-11.881.77A4.058,4.058,0,0,1,2.577,28.64l.162-.434.2-.405,7.978-13.819A36.458,36.458,0,0,0,39,30.2Z",
    transform: "translate(668.334 3389.696)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_383",
    "data-name": "Path 383",
    d: "M33.375,2l.973.016a28.375,28.375,0,0,1,27.4,28.359l-.012.782-.028.778-.073.993-.105.981-.1.722a28.314,28.314,0,0,1-1.285,5.14l-.47,1.249-.62,1.411a28.379,28.379,0,0,1-51.432-.113l-.527-1.2-.211-.539-.324-.88L6.18,38.5q-.206-.692-.377-1.394l-.243-1.1-.2-1.1-.081-.563-.158-1.309-.1-1.48L5,30.375A28.376,28.376,0,0,1,32.4,2.016L33.375,2Z",
    transform: "translate(676.269 3353.107)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRibbon);
export default __webpack_public_path__ + "static/media/ribbon.bf866116eac3b1fa8bd55da9399c40eb.svg";
export { ForwardRef as ReactComponent };